import React from 'react';
import '../../styles/dashboard.css'; // Ensure you create a CSS file for styles

const DashboardUser = () => {
    return (
        <div className="dashboard-container">
            {/* Left Section */}
            <div className="left-section">
                <div className="college-info">
                    <h2>Welcome to P A Polytechnic</h2>
                    <p>
                        P A Polytechnic is committed to excellence in education and provides
                        quality training to prepare students for industry-ready skills.
                    </p>
                </div>
                <img
                    src="https://via.placeholder.com/500x300" // Replace with your institution image URL
                    alt="Institution"
                    className="institution-image"
                />
            </div>

            {/* Right Section */}
            <div className="right-section">
                {/* News and Events */}
                <div className="news-events">
                    <h3>News & Events</h3>
                    <ul className="news-list">
                        <li>Workshop on AI and Machine Learning - Dec 15, 2024</li>
                        <li>Annual Sports Day - Jan 10, 2025</li>
                        <li>Placement Drive - Feb 5, 2025</li>
                    </ul>
                </div>

                {/* Placement Images */}
                <div className="placement-images">
                    <h3>Placements</h3>
                    <div className="image-slider">
                        <img
                            src="https://via.placeholder.com/150x100"
                            alt="Company 1"
                        />
                        <img
                            src="https://via.placeholder.com/150x100"
                            alt="Company 2"
                        />
                        <img
                            src="https://via.placeholder.com/150x100"
                            alt="Company 3"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardUser;
